import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AboutHero from './components/AboutHero';
import AboutIntro from './components/AboutIntro';
import AboutPersona from './components/AboutPersona';
import AboutMethod from './components/AboutMethod';
import { useTitle } from '@/hooks/useTitle';

import PageCta from '@/components/feature/PageCta';

export default function About() {
  useTitle({
    title: '關於琮恩｜保險建築師專業保險規劃',
    description: '認識保險建築師陳琮恩，15年以上專業保險顧問經驗，以建築師思維為客戶量身打造保障藍圖。',
  });
  return (
    <main>
      <Navbar />
      <AboutHero />
      <AboutIntro />
      <AboutPersona />
      <AboutMethod />
      <PageCta />
      <Footer />
    </main>
  );
}
